import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import CssBaseline from "@mui/material/CssBaseline";
import { store } from "./store";
import { MUI_LICENSE_KEY } from "./constants";
import { initializeSelectedProposal } from "./reducers";
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY || "");
store.dispatch(initializeSelectedProposal());

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);
